export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["FATAL"] = 0] = "FATAL";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
    LogLevel[LogLevel["TRACE"] = 5] = "TRACE";
})(LogLevel || (LogLevel = {}));
export var LogSource;
(function (LogSource) {
    LogSource[LogSource["Account"] = 0] = "Account";
    LogSource[LogSource["MyMeals"] = 1] = "MyMeals";
    LogSource[LogSource["OrderFlow"] = 2] = "OrderFlow";
})(LogSource || (LogSource = {}));
